import { datadogRum } from '@datadog/browser-rum';
import { Suspense } from 'react';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router';

import PageSpinner from '../components/molecules/pageSpinner';
import ErrorPage from '../components/pages/errorPage';
import LandingPage from '../components/pages/landingPage';

import ReactRouterErrorBoundary from './reactErrorBoundary';
import Root from './Root';
import { activityRoutes } from './routes/activity';
import { approvalRoutes } from './routes/approvals';
import { cardUserRoutes } from './routes/cardUsers';
import { dashboardRoutes } from './routes/dashboard';
import { demoRoutes } from './routes/demo';
import { errorRoutes } from './routes/error';
import { settlementRoutes } from './routes/manageSettlements';
import { requestRoutes } from './routes/request';
import { settingsRoutes } from './routes/settings';
import { signinRoutes } from './routes/signin';
import { supportRoutes } from './routes/support';
import { supportAdminSettingsRoutes } from './routes/supportSettings';
import { teamRoutes } from './routes/team';
import { teamsManageSettlements } from './routes/teamsManageSettlements';
import { tosRoutes } from './routes/tos';
import { walletRoutes } from './routes/wallet';
import './GoAppStyle.less';

export const excludedPaths = ['signin', 'tos', 'request-demo'];

globalThis.DD_RUM = datadogRum;

const router = createBrowserRouter(
	[
		{
			path: '/',
			element: (
				<Root>
					<div className="content-right">
						<Outlet />
					</div>
				</Root>
			),
			errorElement: (
				<Root>
					<ReactRouterErrorBoundary />
				</Root>
			),
			hydrateFallbackElement: <PageSpinner />,
			children: [
				{ path: '/', element: <LandingPage /> },
				walletRoutes,
				dashboardRoutes,
				errorRoutes,
				activityRoutes,
				approvalRoutes,
				settlementRoutes,
				teamsManageSettlements,
				cardUserRoutes,
				requestRoutes,
				settingsRoutes,
				teamRoutes,
				signinRoutes,
				demoRoutes,
				supportRoutes,
				supportAdminSettingsRoutes,
				tosRoutes,
			],
		},

		{
			path: '*',
			element: (
				<Root>
					<ErrorPage />
				</Root>
			),
		},
	],
	{
		future: {
			//There are no current future flags in React Router v7
		},
	},
);

const GoApp = () => {
	return (
		<Suspense fallback={<PageSpinner isLoading={true} />}>
			<RouterProvider router={router} />
		</Suspense>
	);
};

export default GoApp;
